//= require personalised-config.js
//= require personalised-bundle-utils.js
//= require personalised-utils.js
// CUSTOM: personalised-bundle-manager.js

(function() {
  window.personalised = window.personalised || {};
  
  // Bundle Manager module
  /**
   * Initializes the library page for personalised bundles
   * Loads state, sets up event listeners, and prepares UI components
   * @async - Handles mode initialization asynchronously
   */
  async function initLibraryPage() {
    // Mode is now solely managed by storageManager, no need for debugging mode discrepancy
    
    // Initialize mode using centralized utility
    try {
      if (window.personalised?.utils?.initMode) {
        // Use proper await pattern for mode initialization
        await window.personalised.utils.initMode();
        if (window.personalised.debugMode) console.log(`[Library Init] Mode initialized: ${window.personalised.utils.getMode()}`);
      }
    } catch (e) {
      console.error('Error setting mode in initLibraryPage', e);
    }
    
    // Get config reference
    const config = window.personalised.config || {};
    
    // Initialize performance utils if available
    if (window.personalised.bundleUI && typeof window.personalised.bundleUI.initPerformanceUtils === 'function') {
      window.personalised.bundleUI.initPerformanceUtils();
    }
    
    // Load state once and sync cart
    window.personalised.bundle.load();
    // Ensure cart matches local state on page load
    if (window.personalised.utils && typeof window.personalised.utils.refreshCartFromState === 'function') {
      window.personalised.utils.refreshCartFromState();
    }
    // Update UI using the standardized reference
    window.personalised.updateUI();    
    
    // Use body as fallback for product pages where contentColumn doesn't exist
    const contentColumn = document.querySelector(config.selectors.contentColumn) || document.body;
    if (!contentColumn) {
      console.warn('Content column not found and document.body is unavailable');
      return;
    }
    
    const groups = contentColumn ? contentColumn.querySelector(config.selectors.groupsContainer) : null;
    if (!groups) {
      console.warn('Groups container not found', config.selectors.groupsContainer);
    }
    
    let filteredSection = null;
    let addInProgress = false;
    let labelModalPending = false;
    // CSS classes for button states are now defined in personalised-library.css

    // Collect all products from all groups for filtering
    const allProductCards = Array.from(document.querySelectorAll(config.selectors.productCard));const allProducts = allProductCards.map(card => {
      const productId = card.getAttribute(config.dataAttributes.productId);
      const variantId = card.getAttribute(config.dataAttributes.variantId);
      const collectionId = card.getAttribute(config.dataAttributes.collectionId);
      const available = card.getAttribute(config.dataAttributes.available) !== 'false'; // Convert to boolean, default to true if not specified
      const title = card.querySelector(config.selectors.productTitle)?.textContent || '';
      const nickname = card.querySelector(config.selectors.productNickname)?.textContent || '';
      const description = card.querySelector(config.selectors.productDescription)?.textContent || '';
      const image = card.querySelector(config.selectors.productImage)?.getAttribute('src') || '';
      const url = card.querySelector(config.selectors.productLink)?.getAttribute('href') || '';
      const price = card.querySelector(config.selectors.productPrice)?.textContent || '';
      // Get tags from a data attribute, or fallback to product.tags if available in a hidden element
      let tags = [];
      // Try to find a hidden element with tags (e.g. <span class="product-tags" style="display:none">tag1,tag2</span>)
      const tagEl = card.querySelector('.product-tags');
      if (tagEl) {
        tags = tagEl.textContent.split(',').map(t => t.trim());
      } else if (card.getAttribute('data-tags')) {
        tags = card.getAttribute('data-tags').split(',').map(t => t.trim());
      }
      return { productId, variantId, collectionId, title, nickname, description, image, url, price, tags, card, available };
    });
      const goalButtons = document.querySelectorAll(config.selectors.goalButton);
    if (!goalButtons || goalButtons.length === 0) {
      console.warn('No goal buttons found', config.selectors.goalButton);
    } else {
      goalButtons.forEach(btn => {
        if (!btn) return;
        
        btn.addEventListener('click', function () {
          const goal = btn.getAttribute('data-goal');
          
          // Use requestAnimationFrame to batch DOM operations
          window.requestAnimationFrame(() => {
            if (filteredSection) {
              filteredSection.remove();
              filteredSection = null;
            }
            
            if (goal === 'All') {
              if (groups) groups.style.display = '';
            } else {
              if (groups) groups.style.display = 'none';
              // Filter products by tag (case-insensitive, match substring for robustness)
              const filtered = allProducts.filter(p => p.tags.some(t => t.toLowerCase() === goal.toLowerCase()));
              filteredSection = renderFilteredSection(filtered);
              if (contentColumn && filteredSection) {
                contentColumn.appendChild(filteredSection);
              }
            }
              
            // Use standardized reference to updateUI
            if (window.personalised.updateUI) {
              window.personalised.updateUI();
            }
              
            // Always collapse the goals list on mobile after selecting a goal
            const goalsList = document.querySelector(config.selectors.goalsList);
            if (goalsList && goalsList.classList && 
                window.innerWidth <= config.timing.mobileBreakpoint && 
                goalsList.classList.contains('expanded')) {
              goalsList.classList.remove('expanded');
            }
          });
        });
      });
    }    // --- Initialize handler references early to prevent ReferenceError ---
    // Custom event handlers
    window.personalised._bundleManagerHandlers = window.personalised._bundleManagerHandlers || {};
    const handlers = window.personalised._bundleManagerHandlers;
    
    // Collapsible goals for mobile
    const goalsList = document.querySelector(config.selectors.goalsList);
    const goalsHeading = document.querySelector(config.selectors.goalsHeading);
    // Create the handler function for reuse and proper cleanup
    handlers.goalsHeadingClick = function() {
      goalsList.classList.toggle('expanded');
    };
    
    if (goalsList && goalsHeading) {
      // Direct event listener for goals toggle - static element
      goalsHeading.addEventListener('click', handlers.goalsHeadingClick);
    }
    
    /**
     * Creates and renders a filtered section of products based on selected goal
     * @param {Array} products - Array of product objects to render in the filtered section
     * @returns {HTMLElement} - The created section element
     */
    function renderFilteredSection(products) {
      // Create section container
      const section = document.createElement('div');
      section.className = 'personalised-library-group-section personalised-library-group-section--filtered';
      
      // Create products container
      const productsContainer = document.createElement('div');
      productsContainer.className = 'personalised-library-products';
        // Handle empty state
      if (products.length === 0) {
        const emptyMessage = document.createElement('div');
        if (emptyMessage) {
          emptyMessage.style.padding = '2em';
          emptyMessage.textContent = config.uiLabels.noProductsFound || 'No products found';
          if (productsContainer) {
            productsContainer.appendChild(emptyMessage);
          }
        }
      } else {
        // Prepare all product cards at once with a document fragment
        const fragment = document.createDocumentFragment();
        
        // Generate HTML for all products and add to fragment in one batch
        const productsHTML = products.map(productCardHtml).join('');
        const tempDiv = document.createElement('div');
        if (tempDiv) {
          tempDiv.innerHTML = productsHTML;
          
          // Move all nodes from tempDiv to fragment
          while (tempDiv.firstChild) {
            if (fragment) {
              fragment.appendChild(tempDiv.firstChild);
            }
          }
          
          // Append all product cards to the products container at once
          if (productsContainer && fragment) {
            productsContainer.appendChild(fragment);
          }
        }
      }
      
      // Append products container to section
      section.appendChild(productsContainer);
      
      return section;
    }
    
    /**
     * Generates HTML for a product card
     * @param {Object} p - Product object with properties like title, image, price, etc.
     * @returns {string} - HTML string for the product card
     */
    function productCardHtml(p) {
      return `
        <div class="personalised-library-product-card" data-variant-id="${p.variantId}" data-product-id="${p.productId}" data-collection-id="${p.collectionId}" data-available="${p.available !== false}">
          <a class="personalised-library-product-link" href="${p.url}">
            <div class="personalised-library-product-image-wrapper">
              <img class="personalised-library-product-image" src="${p.image}" alt="${p.title}" style="object-fit: cover; height: 160px; width: 100%; max-height: 160px;">
            </div>
            <div class="personalised-library-product-details-wrapper">
              <div class="personalised-library-product-title">${p.title}</div>
              ${p.nickname ? `<div class="personalised-library-product-nickname">${p.nickname}</div>` : ''}
              ${p.description ? `<p class="personalised-library-product-description">${p.description}</p>` : ''}
            </div>
          </a>
          <div class="personalised-library-product-bottom">
            <div class="personalised-library-product-price">
              <span class="personalised-library-product-price">${p.price}</span>
            </div>
            <button type="button" class="personalised-library-action-btn" data-add-to-pack>${config.uiLabels.addToPack}</button>
          </div>
        </div>
      `;
    }
    
    /**
     * Sets the visual state of Add to Pack buttons during sync operations
     * @param {boolean} inProgress - Whether a sync operation is in progress
     * @param {HTMLElement} currentButton - The specific button that triggered the operation
     * @param {boolean} justFeedback - Whether to only show feedback on the current button without disabling others
     */
    function setAddInProgressState(inProgress, currentButton, justFeedback = false) {
      const allAddBtns = document.querySelectorAll(config.selectors.actionButton);
      if (inProgress) {
        if (justFeedback && currentButton) {          // Just give visual feedback for the clicked button, don't disable others
          currentButton.classList.add('add-inprogress-other');
          setTimeout(() => {
            currentButton.classList.remove('add-inprogress-other');
          }, config.timing.buttonFeedbackDuration);
        } else {          // Full blocking state, typically only during actual sync
          allAddBtns.forEach(btn => {
            if (!btn.classList.contains('added') && !btn.disabled) {
              btn.classList.add('add-inprogress');
            }
            btn.classList.remove('add-inprogress-active');
          });
          if (currentButton) {
            currentButton.classList.add('add-inprogress-active');
          }
        }      } else {
        allAddBtns.forEach(btn => {
          btn.classList.remove('add-inprogress', 'add-inprogress-active', 'add-inprogress-other');
        });
      }
    }

    function proceedWithAddToPack({ productId, variantId, collectionId, sellingPlanId }) {
      try {
        window.personalised.bundle.addItem({ productId, variantId, collectionId, quantity: 1, sellingPlanId });
        // PR-2.4: mark state modified so the review-page timestamp skip does not suppress
        // a defensive sync if this add-to-pack sync fails before completing.
        window.personalised.storageManager?.markBundleModified();
        window.personalised.updateUI();

        if (window.personalised.bundleUI?.showAddToPackModal) {
          window.personalised.bundleUI.showAddToPackModal();
        }

        if (window.personalised.utils.getMode() !== window.personalised.config.modes.EDIT) {
          window.personalised.utils.debouncedRefreshCartFromState(config.uiLabels.bundleItemAdded);
        }
        if (window.__isTapcart === true) {
          try { localStorage.setItem('pack_dirty', String(Date.now())); } catch (e) {}
        }
      } catch (err) {
        showBundleErrorModal();
        console.error('Error adding item to bundle:', err);
      }
    }

    // --- Store additional handler references for teardown ---
    // Note: The handlers variable is already defined above, so we don't redefine it here

    // Handler for UI update events
    handlers.updateUI = window.personalised.updateUI || 
      (window.personalised.uiHandlers && window.personalised.uiHandlers.updateUI);

    // Handler for sync events
    handlers.syncStarted = function() { setAddInProgressState(true); };
    handlers.syncCompleted = function() { addInProgress = false; setAddInProgressState(false); };
    handlers.syncFailed = function() { addInProgress = false; setAddInProgressState(false); };

    // Handler for "Add to Pack" button clicks - uses delegation for dynamic product cards
    handlers.handleAddToPackClick = function(e) {
      const button = e.target.closest('button[data-add-to-pack]');
      if (!button || button.disabled) return;
      if (labelModalPending) return;

      // 1. Button state feedback
      setAddInProgressState(true, button, true);
      setTimeout(() => {
        const utils = window.personalised.utils;
        if (!utils || !utils.syncState || !utils.syncState.syncInProgress) {
          setAddInProgressState(false);
        }
      }, config.timing.buttonFeedbackDuration);

      // 2. Validate element and extract data
      const el = button.closest('[data-variant-id]');
      const variantId = window.personalised.utils.normalizeShopifyId(el.dataset.variantId);
      const productId = window.personalised.utils.normalizeShopifyId(el.dataset.productId);
      const collectionId = el.dataset.collectionId;
      const isAvailable = el.dataset.available !== 'false';
      
      // Get the current bundle frequency and determine the correct selling plan label
      const currentFrequency = window.personalised.bundle.getFrequency() || '30'; 
      const sellingPlanLabel = window.personalised.config?.subscription?.DEFAULT_SELLING_PLAN_LABELS?.[currentFrequency] || '30_day_subscription';
      const sellingPlanId = window.personalised.sellingPlans?.[variantId]?.[sellingPlanLabel];

      if (!isAvailable) {
        console.warn(`Attempted to add sold-out variant (${variantId})`);
        return;
      }

      // 3. Block if already in bundle
      const isInBundle = window.personalised.bundle.isInBundle(variantId) ||
                        (typeof window.personalised.bundle.isProductInBundle === 'function' &&
                          window.personalised.bundle.isProductInBundle(productId));
      if (isInBundle) return;

      // 4. Allergy / Pregnancy blocker logic
      const allergy = localStorage.getItem('vitable_allergy');
      const pregnancy = localStorage.getItem('vitable_pregnancy');

      // Only show disclaimer modal if there are meaningful values that require warnings
      const hasRelevantAllergy = allergy && !['no', 'none', ''].includes(allergy.toLowerCase().trim());
      const hasRelevantPregnancy = pregnancy && !['no', 'none', ''].includes(pregnancy.toLowerCase().trim());

      if (hasRelevantAllergy || hasRelevantPregnancy) {
        try {
          if (!sessionStorage.getItem('personalised_disclaimer_modal_shown')) {
            const show = window.personalised?.disclaimerModal?.showDisclaimerModal;
            if (typeof show === 'function') {
              show({ allergy, pregnancy }).then(confirmed => {
                if (confirmed) {
                  try { sessionStorage.setItem('personalised_disclaimer_modal_shown', 'true'); } catch (e) {}
                  proceedWithAddToPack({ productId, variantId, collectionId, sellingPlanId });
                } else {
                  setAddInProgressState(false);
                  console.debug('[Add to Pack] Cancelled by user due to disclaimer modal');
                }
              });
              return; // Block default flow
            } else {
              console.warn('[Bundle Manager] Disclaimer modal unavailable; proceeding without modal.');
            }
          }
        } catch (e) { /* sessionStorage unavailable, proceed */ }
      }

      // 5. Label modal for users without disclaimer conditions
      if (!(hasRelevantAllergy || hasRelevantPregnancy)) {
        try {
          if (!sessionStorage.getItem('personalised_label_modal_shown')) {
            const showLabelModal = window.personalised?.labelModal?.showLabelModal;
            if (typeof showLabelModal === 'function') {
              labelModalPending = true;
              showLabelModal().then(() => {
                try {
                  sessionStorage.setItem('personalised_label_modal_shown', 'true');
                } catch (e) {
                  // sessionStorage unavailable, continue anyway
                }
                proceedWithAddToPack({ productId, variantId, collectionId, sellingPlanId });
              }).finally(() => {
                labelModalPending = false;
              });
              return; // Block default flow
            }
          }
        } catch (e) {
          // Label modal check failed, proceed anyway
        }
      }

      // 6. Proceed normally if no blockers
      proceedWithAddToPack({ productId, variantId, collectionId, sellingPlanId });
    };


    // --- Attach listeners using stored handlers ---
    // Guard against duplicate eventBus listener registration
    if (window.personalised && window.personalised.eventBus && 
        typeof window.personalised.eventBus.on === 'function' &&
        !window.personalised._bundleManagerEventBusBound) {
      window.personalised.eventBus.on('syncStarted', handlers.syncStarted);
      window.personalised.eventBus.on('syncCompleted', handlers.syncCompleted);
      window.personalised.eventBus.on('syncFailed', handlers.syncFailed);
      // Note: Direct UI updates now replace the following events:
      // 'itemAdded', 'itemRemoved', 'frequencyChanged', 'stateReset'
      window.personalised.eventBus.on('bundleStateLoaded', handlers.updateUI);
      window.personalised._bundleManagerEventBusBound = true;
    }
    if (contentColumn && !contentColumn.dataset.bundleManagerBound) {
      contentColumn.addEventListener('click', handlers.handleAddToPackClick);
      contentColumn.dataset.bundleManagerBound = 'true';
    }
    if (goalsHeading && !goalsHeading.dataset.bundleManagerGoalsBound) {
      goalsHeading.addEventListener('click', handlers.goalsHeadingClick);
      goalsHeading.dataset.bundleManagerGoalsBound = 'true';
    }
    // ...existing code...
  }
  
  window.personalised.bundleManager = {
    /**
     * Initializes the library page for personalised bundles
     */
    init: initLibraryPage,
    /**
     * Tears down the bundle manager instance
     * Removes all eventBus and DOM listeners added in this file
     */
    teardown: function() {
      const config = window.personalised.config || {};
      const handlers = window.personalised._bundleManagerHandlers || {};
      // Remove eventBus listeners
      if (window.personalised.eventBus) {
        window.personalised.eventBus.off('syncStarted', handlers.syncStarted);
        window.personalised.eventBus.off('syncCompleted', handlers.syncCompleted);
        window.personalised.eventBus.off('syncFailed', handlers.syncFailed);
        // Note: Event listeners for the following events have been removed 
        // as they were replaced with direct UI updates:
        // 'itemAdded', 'itemRemoved', 'frequencyChanged', 'stateReset'
        window.personalised.eventBus.off('bundleStateLoaded', handlers.updateUI);
      }
      // Remove DOM listeners
      const contentColumn = document.querySelector(config.selectors?.contentColumn);
      if (contentColumn && handlers.contentColumnClick) {
        contentColumn.removeEventListener('click', handlers.contentColumnClick);
      }
      const goalsHeading = document.querySelector(config.selectors?.goalsHeading);
      if (goalsHeading && handlers.goalsHeadingClick) {
        goalsHeading.removeEventListener('click', handlers.goalsHeadingClick);
      }
      // Clean up handler references
      delete window.personalised._bundleManagerHandlers;
    }
  };
})();